import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const notificationBellIcon = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 2C6.34315 2 5 3.34315 5 5V7.5C5 8.5 4.5 9.5 3.5 10.5L3 11H13L12.5 10.5C11.5 9.5 11 8.5 11 7.5V5C11 3.34315 9.65685 2 8 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 11V11.5C9 12.3284 8.32843 13 7.5 13H8.5C7.67157 13 7 12.3284 7 11.5V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <circle cx="8" cy="13.7" r="0.7" fill="currentColor"/>
</svg>`
);
